<script>

export default {
  name: "AuthByCode",
  data() {
    return {
      isProcessing: false,
      authCode: null,
    };
  },
  created() {
    console.log('!!!CREATED');
    if (this.$route && this.$route.params && this.$route.params.authCode && this.$route.params.authCode != '') {
      this.authCode = this.$route.params.authCode;
    }
  },
  mounted() {
    console.log('!!!MOUNTED');
    if (this.authCode && this.authCode != null && !this.isProcessing) {
      console.log('!!!!!!', this.authCode);
      this.isProcessing = true;
      this.loginByCode(this.authCode);
    }
  },
  methods: {
    auth () {
      this.$store.dispatch("initApp")
      this.$router.push('/');
    },
    loginByCode(code) {
      if (code) {
        this.$store.dispatch('loginByCode', {code})
            .then((response) => {
              this.authCode = null;
              if (response && response.data && response.data._status) {
                this.auth();
              }
            })
            .catch(() => {
            });
      }
    },
  }
};
</script>

<template>
  <div class=""></div>
</template>


